export const styles = {
  spyWrapper: {
    position: 'relative',
    padding: '20px 0px',
  },
  controls: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 40px',
  },
}
